import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M2.194 3.427c.3916-.3047.9568-.277 1.326.083l16.95 16.98c.39.39.39 1.02 0 1.41l-.094.083a.9959.9959 0 01-1.316-.083l-6.61-6.61-5.56 5.56c-.09.1-.22.15-.35.15H3.5c-.28 0-.5-.22-.5-.5v-3.04c0-.14.05-.26.15-.36l5.56-5.57L2.1 4.92a.9959.9959 0 010-1.41zm11.8585 2.7655L17.8 9.94l-2.5173 2.5173-3.7476-3.7477zM16.96 3.29c.39-.39 1.02-.39 1.41 0l2.34 2.34c.39.39.39 1.02 0 1.41l-1.83 1.83-3.75-3.75z"
  }],
  circles: []
};
var EditOffIcon = function EditOffIcon(props) {
  return renderIcon(props, iconType);
};
export { EditOffIcon };